<template>
  <div class="custom-nav navbar-default">
        <div class="container">
            <!-- Brand and toggle get grouped for better mobile display -->
            <div class="navbar-header">
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <a class="custom-brand" href="#">Electchain.io</a>
            </div>
            <div class="collapse navbar-collapse navbar-ex1-collapse">
                <ul class="nav navbar-nav">
                    <li class="menu-item"><a v-on:click="desc()">¿Qué es? </a></li>
                    <ul class="nav navbar-nav">
                        <li class="menu-item"><a v-on:click="objs()">Objetivos</a></li>
                        <ul class="nav navbar-nav">
                            <li class="menu-item"><a v-on:click="proc()">Registro<i class="fa fa-comments-o"></i></a></li>
							<ul class="nav navbar-nav">
                                <li class="menu-item"><a v-on:click="team()">Redes<i class="fa fa-comments-o"></i></a></li>
							</ul>
                        </ul>
                    </ul>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
require('./navbar/jquery.js')
require('./navbar/bootstrap.js')

$('ul.dropdown-menu [data-toggle=dropdown]').on('click', function(event) {
    // Avoid following the href location when clicking
    event.preventDefault(); 
    // Avoid having the menu to close when clicking
    event.stopPropagation(); 
    // If a menu is already open we close it
    //$('ul.dropdown-menu [data-toggle=dropdown]').parent().removeClass('open');
    // opening the one you clicked on
    $(this).parent().addClass('open');

    var menu = $(this).parent().find("ul");
    var menupos = menu.offset();
  
    if ((menupos.left + menu.width()) + 30 > $(window).width()) {
        var newpos = - menu.width();      
    } else {
        var newpos = $(this).parent().width();
    }
    menu.css({ left:newpos });

});

export default {
    name: 'Navbar',
    data () {
        return {
            prod_name: 'ElectChain.io',
            nav_items: [
                {title: '¿Qué es?'}, 
                {title: 'Objetivos'},
                {title: 'El proceso'},
                {title: 'El equipo'},
	        ]
        }	        
    },
    methods: {
        desc () {
            $(window).scrollTop($('#desc-section').position().top);
        },
        objs (){
            $(window).scrollTop($('#objs-section').position().top);
        },
        proc (){
            $(window).scrollTop($('#proc-section').position().top);
        },
        sched (){
            $(window).scrollTop($('#time-section').position().top);
        },
        team (){
            $(window).scrollTop($('#final-content').position().top);
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.custom-nav{
    background-color: #102032 !important;
}
.custom-brand{
    float: left;
    height: 50px;
    padding: 15px 15px;
    font-size: 18px;
    line-height: 20px;
}
a{
    color: white !important;
    cursor: pointer;
}
</style>

<style scoped src="./navbar/bootstrap.css"/>



// WEBPACK FOOTER //
// src/components/Navbar.vue